// extracted by mini-css-extract-plugin
export default {"catalog":"Catalog_catalog__w82jE","catalog_items-block":"Catalog_catalog_items-block__ZTAT8","catalog_text":"Catalog_catalog_text__Et-uk"};